import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import "./header.css";
import { useSelector } from "react-redux";
import { logout } from '../../../redux/actions'
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";

const Header = () => {

    const dispatch = useDispatch()
    let loggedInUser = useSelector((state) => state.userDetails);
    const [pages, setPages] = useState()

    useEffect(() => {
        fetchPages();
    }, [])

    const fetchPages = async () => {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/v1/cms/get-pages-by-header`);
        setPages(response.data);
    }

    return (
        <header id="DefaultHeader" className="bg-white header">
            <div className="container">
                <nav className="navbar navbar-expand-lg navbar-light main-nav fill w-100  d-flex justify-content-between flex-wrap align-items-center">
                    <div className="bid-logo">
                        <Link className="navbar-brand" to={'/'}><img src={logo} alt="logo" /></Link>
                    </div>
                    <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse bid-nav justify-content-end" id="navbarResponsive">
                        <ul className="navbar-nav list-unstyled align-items-center">
                            <li className="nav-item">
                                <Link className={`nav-link ${window.location.pathname === "/" ? "active" : ""}`} to="/">home</Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`nav-link ${window.location.pathname === "/about-us" ? "active" : ""}`} to="/about-us">about</Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`nav-link ${window.location.pathname === "/help" ? "active" : ""}`} to="/help">help/faq</Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`nav-link ${window.location.pathname === "/contact-us" ? "active" : ""}`} to="/contact-us">contact</Link>
                            </li>
                            {pages && pages.map((page, key) => {
                                return (
                                    <li className="nav-item" key={key}>
                                        <Link className={`nav-link ${window.location.pathname === `/cms/${page.slug}` ? "active" : ""}`} to={`/cms/${page.slug}`}>{page.title}</Link>
                                    </li>
                                )
                            })}
                            {loggedInUser && !loggedInUser.isLoggedIn && <>
                                <li className="nav-item mbl-text-center">
                                    <Link className="btn btn-theme" to="/login"> Login </Link>
                                </li>
                                <li className="nav-item mbl-text-center">
                                    <Link className="btn btn-theme btn-custom" to="/sign-up"> Register </Link>
                                </li>
                            </>}

                            {loggedInUser && loggedInUser.isLoggedIn && <>
                                <li className="nav-item">
                                    <div class="dropdown">
                                        <button class="btn dropdown-toggle" type="button" id="userButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <img className="profile-pic" src={loggedInUser.user.image ? `${process.env.REACT_APP_SERVER_URL}/images/${loggedInUser.user.image}` : `${process.env.REACT_APP_URL}/static/images/profile-info.png`} alt="profilePhoto" /> {loggedInUser.user.firstname}
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="userButton">

                                            <div className="dropdown-options">
                                                <Link class="dropdown-item" to="/dashboard"><span>Dashboard</span></Link>
                                                <Link class="dropdown-item" to={loggedInUser.user.role[0] === "admin" ? "/admin-listing" : "/user-listing"}>Listing</Link>
                                                {loggedInUser.user.role[0] === "user" && <Link class="dropdown-item" to="/my-bids">My Bids</Link>}
                                                <Link class="dropdown-item" to="/settings">Settings</Link>
                                            </div>

                                            <div class="dropdown-divider"></div>
                                            <div class="dropdown-item"><button className="btn btn-theme" onClick={() => { dispatch(logout()); }}> Logout </button></div>
                                        </div>
                                    </div>
                                </li>
                            </>}
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    );
}

export default Header;